import { memo } from "react";
import { WarehouseInfoCardProps } from "./types";
import { useTranslate } from "helpers";

const WarehouseInfoCard: React.FC<WarehouseInfoCardProps> = (props) => {
  const { fleetWarehouseDetail } = props;

  const { t } = useTranslate();

  return (
    <div>
      {/* <div className="flex justify-between items-center pt-3 pl-4 pr-3">
        <div className="text-md font-bold text-slate-600 truncate">
          {fleetWarehouseDetail.name}
        </div>
      </div> */}

      <div className="pt-4 px-4">
        <div className="grid grid-cols-1 gap-3 mb-4">
          <div className="border border-slate-200 bg-slate-50 p-3 rounded-sm min-h-[70px]">
            <div className="text-sm text-slate-600">
              {t("admin.fleet.warehouse.detail.info.name")}
            </div>
            <div className="text-md font-medium text-slate-800 truncate">
              {fleetWarehouseDetail.name}
            </div>
          </div>
          <div className="border border-slate-200 bg-slate-50 p-3 rounded-sm min-h-[70px]">
            <div className="text-sm text-slate-600">Opis</div>
            {fleetWarehouseDetail.description ? (
              <div className="text-md text-slate-800 whitespace-pre-line">{fleetWarehouseDetail.description}</div>
            ) : (
              <div className="text-md text-slate-400">Opis nije upisan</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(WarehouseInfoCard);
